import {Injectable, signal, WritableSignal} from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoaderService {

  count: WritableSignal<number> = signal(0);
  add(): void {
    this.count.update((value: number): number => value + 1);
  }
  remove(): void {
    this.count.update((value: number): number => value > 0 ? value - 1 : value);
  }

}
